import { combineReducers } from '@reduxjs/toolkit';
import lunaStreamsReducers from '@vlabs/monokit/entities/sources/luna-streams/store/reducer';
import vlAccessReducers from '@vlabs/pages/sources/vl-access/reducers';
import vaReporterReducers from '@vlabs/pages/va-reporter/reducer';

import accountsSlice from '@vlabs/pages/accounts/store';
import accountSlice from '@vlabs/pages/auth/store';
import departmentsSlice from '@vlabs/pages/departments/store';
import eventsSlice from '@vlabs/pages/events/events/store';
import latestEventsSlice from '@vlabs/pages/events/latest-events/store';
import handlerSlice from '@vlabs/pages/handlers/store';
import listsSlice from '@vlabs/pages/lists/store';
import notificationsSlice from '@vlabs/pages/notifications/store';
import thermoSlice from '@vlabs/pages/thermo/store';
import timeTrackingSlice from '@vlabs/pages/time-tracking-tasks/store';

import appSlice from './appSlice';

export default combineReducers({
  app: appSlice,
  account: accountSlice,
  accounts: accountsSlice,
  lists: listsSlice,
  events: eventsSlice,
  latestEvents: latestEventsSlice,
  departments: departmentsSlice,
  handlers: handlerSlice,
  notifications: notificationsSlice,
  reports: timeTrackingSlice,
  thermo: thermoSlice,
  ...vaReporterReducers,
  ...vlAccessReducers,
  ...lunaStreamsReducers,
});
